import { render, staticRenderFns } from "./SonsMergeCard.vue?vue&type=template&id=c95e0a24&scoped=true&"
import script from "./SonsMergeCard.vue?vue&type=script&lang=js&"
export * from "./SonsMergeCard.vue?vue&type=script&lang=js&"
import style0 from "./SonsMergeCard.vue?vue&type=style&index=0&id=c95e0a24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95e0a24",
  null
  
)

export default component.exports